import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../variables/api/axiosInstance";
import { Modal, Select } from "antd";
import { searchRoute } from "../../hooks/useSearch";

const AddHabilitation = ({ show, handleClose, editMode, selectedHabilitation }) => {
  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [routes, setRoutes] = useState([]);
  const [libelleHabilitation, setLibelleHabilitation] = useState("");
  const [route, setRoute] = useState("");
  const [type, setType] = useState("");
  const [descriptionHabilitation, setDescriptionHabilitation] = useState("");
  const [selectedModule, setSelectedModule] = useState(0);
  const [routeSearch, setRouteSearch] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    // console.log("type: ", typeof selectedModule);
    const mod = modules.find((e) => e.moduleId === parseInt(selectedModule));
    const r = routes.find((e) => e.path === route);
    console.log(mod);
    const hab = editMode
      ? {
        libelle: libelleHabilitation,
        description: descriptionHabilitation,
        module: mod,
        type: type,
        route: r,
        habilitationId: selectedHabilitation.habilitationId,
        codeHabilitation: selectedHabilitation.codeHabilitation
      } : {
        libelle: libelleHabilitation,
        description: descriptionHabilitation,
        module: mod,
        type: type,
        route: r,
      };
    console.log("hab; ", hab);
    if (editMode) {
      selectedHabilitation.libelle = libelleHabilitation;
      selectedHabilitation.description = descriptionHabilitation;
      selectedHabilitation.module = mod;
      selectedHabilitation.type = type;
      selectedHabilitation.route = r;
      axiosInstance
        .put(`/api/habilitation`, JSON.stringify(selectedHabilitation))
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          toast("Habilitation modifiée avec succès");

          handleClose();
        })
        .catch((err) => {
          console.log(err);
          toast("Erreur lors de la mise à jour de l'habilitation");
          setLoading(false);
        });
    } else {
      axiosInstance
        .post(`/api/habilitation`, JSON.stringify(hab))
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          toast("Habilitation ajoutée avec succès");

          handleClose();
        })
        .catch((err) => {
          console.log(err);
          toast("Erreur lors de l'ajout de l'habilitation");
          setLoading(false);
        });
    }

  };

  const debouncedSetRouteSearchInput = useCallback((value) => {
    const handler = setTimeout(() => {
      setRouteSearch(value);
    }, 10); // Wait 500ms after user stops typing
    // Clean up previous timeout
    return () => clearTimeout(handler);
  }, []);

  useEffect(() => {
    axiosInstance
      .get(`/api/module`)
      .then((res) => {
        setModules(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    // axiosInstance
    //   .get(`/api/route`)
    //   .then((res) => {
    //     console.log(res.data);
    //     setRoutes(res.data.content);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }, []);

  useEffect(() => {
    searchRoute(routeSearch)
      .then((res) => {
        setRoutes(res.data.content);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [routeSearch]);

  useEffect(() => {
    if (editMode && selectedHabilitation) {
      setLibelleHabilitation(selectedHabilitation.libelle || "");
      // route peut être un objet {path} ou une chaîne, ou null (habilitation ACTION sans route).
      setRoute(selectedHabilitation.route?.path ?? selectedHabilitation.route ?? "");
      setType(selectedHabilitation.type || "");
      setDescriptionHabilitation(selectedHabilitation.description || "");
      // ⚠️ module peut être NULL (habilitation de type ACTION non liée à un module) →
      // optional chaining obligatoire, sinon « Modifier » plantait (TypeError).
      setSelectedModule(selectedHabilitation.module?.moduleId ?? "");
    }
  }, [selectedHabilitation, editMode]);

  return (
    <Modal open={show} onCancel={handleClose} width={800} footer={null} centered>
      {/* <Modal.Body> */}
      <button
        type="button"
        className="btn-close"
        onClick={handleClose}
        aria-label="Close"
      ></button>
      <div className="text-center mb-6">
        <h4 className="address-title mb-2"> {editMode ? "Modifier l'" : "Ajouter une "}habilitation</h4>
        <p className="address-subtitle">
          {editMode ? "Modifier l'" : "Ajouter une nouvelle "}habilitation à un module
        </p>
      </div>
      <form id="addNewAddressForm" className="row g-4" onSubmit={onSubmit}>

        <div className="col-6">
          <label className="form-label" htmlFor="modalAddressCountry">
            Module
          </label>
          <select
            id="modalEditUserLanguage"
            name="modalEditUserLanguage"
            class="select2 form-select"
            onChange={(e) => setSelectedModule(e.target.value)}
            value={selectedModule}
          >
            <option value="">Sélectionner le module</option>
            {modules?.map((mod, id) => (
              <option key={id} value={mod.moduleId}>
                {mod.nom}
              </option>
            ))}
          </select>
        </div>
        <div className="col-6 col-md-6">
          <label className="form-label" htmlFor="modalAddressFirstName">
            Libellé
          </label>
          <input
            type="text"
            id="modalAddressFirstName"
            onChange={(e) => setLibelleHabilitation(e.target.value)}
            value={libelleHabilitation}
            className={`form-control`}
            placeholder="Libellé de l'habilitation"
            name="libelle"
          />
        </div>
        <div className="col-6 col-md-6">
          <label className="form-label" htmlFor="route">
            Route
          </label>
          <br />
          <Select
            showSearch
            placeholder="Sélectionner une route"
            optionFilterProp="children"
            onChange={(e) => setRoute(e)}
            searchValue={routeSearch}
            onSearch={(value) => {
              // console.log(value);
              debouncedSetRouteSearchInput(value);
            }}
            value={route}
            style={{ width: "100%", zIndex: 2000 }}
            filterOption={false}
            options={routes?.map((r) => ({ label: r.label, value: r.path }))}
          />
        </div>
        <div className="col-6">
          <label className="form-label" htmlFor="type">
            Type
          </label>
          <select
            id="type"
            name="type"
            class="select2 form-select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="">Sélectionner le type d'habilitation</option>
            <option value="PAGE"> PAGE </option>
            <option value="API"> API </option>
            <option value="ACTION"> ACTION </option>
          </select>
        </div>
        <div className="col-12 col-md-12">
          <label className="form-label" htmlFor="modalAddressFirstName">
            Description
          </label>
          <textarea
            type="text"
            id="modalAddressFirstName"
            onChange={(e) => setDescriptionHabilitation(e.target.value)}
            className={`form-control`}
            placeholder="Description de l'habilitation"
            name="description"
            value={descriptionHabilitation}
          ></textarea>
        </div>
        <div className="col-12 text-center">
          <button
            type="submit"
            className="btn btn-primary me-3"
            disabled={loading}
          >
            {loading && (
              <span
                class="spinner-grow me-1"
                role="status"
                aria-hidden="true"
              ></span>
            )}
            {loading ? `Enregistrement...` : `Enregistrer`}
          </button>
          <button
            type="reset"
            className="btn btn-label-secondary"
            onClick={handleClose}
          >
            Annuler
          </button>
        </div>
      </form>
      {/* </Modal.Body> */}
    </Modal>
  );
};

export default AddHabilitation;
